// 환경 확인
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname.startsWith("d24h19hwoobp27");

// 개발 환경 설정
const devConfig = {
  Auth: {
    userPoolId: "ap-northeast-2_zXLzPphjn",
    userPoolWebClientId: "2j0tibhs3utg5eag0ak795e97m",
    identityPoolId: "ap-northeast-2:8dd59a9d-4b40-490f-a21d-b4dec4de7a61",
  },
  aws_cloud_logic_custom: [
    {
      name: "MainApi",
      endpoint:
        "https://rsrferzde2.execute-api.ap-northeast-2.amazonaws.com/Prod",
    },
    {
      name: "UnAuth",
      endpoint:
        "https://rsrferzde2.execute-api.ap-northeast-2.amazonaws.com/Prod",
    },
  ],
};

// 운영 환경 설정
const prodConfig = {
  Auth: {
    userPoolId: "ap-northeast-2_zXLzPphjn",
    userPoolWebClientId: "2j0tibhs3utg5eag0ak795e97m",
    identityPoolId: "ap-northeast-2:8dd59a9d-4b40-490f-a21d-b4dec4de7a61",
  },
  aws_cloud_logic_custom: [
    {
      name: "MainApi",
      endpoint:
        "https://rsrferzde2.execute-api.ap-northeast-2.amazonaws.com/Prod/",
    },
    {
      name: "UnAuth",
      endpoint:
        "https://rsrferzde2.execute-api.ap-northeast-2.amazonaws.com/Prod/",
    },
  ],
};

// 환경에 따라 설정 선택
const config = isLocalhost ? devConfig : prodConfig;

// 공통 설정
const awsmobile = {
  aws_project_region: "ap-northeast-2",
  Auth: {
    region: "ap-northeast-2",
    ...config.Auth,
  },
  aws_cloud_logic_custom: config.aws_cloud_logic_custom.map((api) => ({
    ...api,
    region: "ap-northeast-2",
  })),
};

export default awsmobile;
